import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

export interface VolunteerCategory {
  id: string;
  key: string;
  label: string;
  sort_order: number;
  is_active: boolean;
}

export const useVolunteerCategories = () => {
  return useQuery<VolunteerCategory[]>({
    queryKey: ['volunteerCategories'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('volunteer_categories')
        .select('id, key, label, sort_order, is_active')
        .order('sort_order', { ascending: true })
        .order('label', { ascending: true });
      if (error) throw error;
      return (data as VolunteerCategory[]) ?? [];
    },
    staleTime: 5 * 60_000,
  });
};
